import React from "react";

export const LessonExecutionStatusBadge = ({
  isComplete,
  isGood,
  isBad,
  executionUrl,
  onClick,
}: {
  isComplete: boolean;
  isGood: boolean;
  isBad: boolean;
  executionUrl: string | null;
  onClick: (url) => void;
}) => {
  return isComplete ? (
    <a
      className={isBad ? "link-danger" : "link-success"}
      href={executionUrl!!} // The url is included if the execution is completed
      onClick={onClick}
    >
      <div
        style={{
          display: "inline-block",
          border: "1px solid",
          borderRadius: "15px",
          padding: "2px 7px 2px 7px",
        }}
      >
        <div className="text-center" style={{ minWidth: "30px" }}>
          {isBad ? "✓-" : isGood ? "✓+" : "✓ "}
        </div>
      </div>
    </a>
  ) : (
    <div
      style={{
        display: "inline-block",
        border: "1px dashed",
        borderRadius: "25px",
        padding: "2px 7px 2px 7px",
      }}
      className="border-secondary text-secondary"
    >
      <div className="text-center" style={{ minWidth: "30px" }}>
        <span
          style={{
            height: "1em",
            width: "1em",
            lineHeight: "1",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          ◐
        </span>
      </div>
    </div>
  );
};
